import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { fmtDay } from "@/lib/dates";

// Single day picker showing UK dates; value/onChange use YYYY-MM-DD.
export default function DatePicker({ value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const d = value ? new Date(`${value}T00:00:00`) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className="h-9 w-full justify-start gap-2 bg-white font-normal" data-testid={testid}>
          <CalendarDays className="h-4 w-4 text-teal-700" /> {value ? fmtDay(value) : <span className="text-slate-400">Pick a date</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" collisionPadding={8} className="w-auto p-0" data-testid={`${testid}-popover`}>
        <Calendar mode="single" weekStartsOn={1} selected={d} defaultMonth={d}
          onSelect={(x) => { if (x) { onChange(x.toLocaleDateString("en-CA")); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
